export const STATIC_OBS_URL = process.env.PUBLIC_STATIC_OBS_URL || ''
export const API_URL = process.env.PUBLIC_API_URL || ''
// console.log('STATIC_OBS_URL', { STATIC_OBS_URL, API_URL })
